/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyCodeConfirmReqVo
 */
export interface VerifyCodeConfirmReqVo {
    /**
     * 验证码类型 1 短信， 2 邮箱，REGISTER/RESET_PASSWORD场景必传
     * @type {number}
     * @memberof VerifyCodeConfirmReqVo
     */
    type?: number;
    /**
     * 验证码接收目标（手机号或邮箱地址），REGISTER/RESET_PASSWORD场景必传
     * @type {string}
     * @memberof VerifyCodeConfirmReqVo
     */
    target?: string;
    /**
     * 用户收到的验证码
     * @type {string}
     * @memberof VerifyCodeConfirmReqVo
     */
    code?: string;
    /**
     * 场景编码：REGISTER/RESET_PASSWORD/CHANGE_PASSWORD/CHANGE_BANK_CARD
     * @type {string}
     * @memberof VerifyCodeConfirmReqVo
     */
    scene?: string;
    /**
     * 用户ID，CHANGE_PASSWORD/CHANGE_BANK_CARD场景必传
     * @type {number}
     * @memberof VerifyCodeConfirmReqVo
     */
    userId?: number;
}

/**
 * Check if a given object implements the VerifyCodeConfirmReqVo interface.
 */
export function instanceOfVerifyCodeConfirmReqVo(value: object): value is VerifyCodeConfirmReqVo {
    return true;
}

export function VerifyCodeConfirmReqVoFromJSON(json: any): VerifyCodeConfirmReqVo {
    return VerifyCodeConfirmReqVoFromJSONTyped(json, false);
}

export function VerifyCodeConfirmReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyCodeConfirmReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'target': json['target'] == null ? undefined : json['target'],
        'code': json['code'] == null ? undefined : json['code'],
        'scene': json['scene'] == null ? undefined : json['scene'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function VerifyCodeConfirmReqVoToJSON(json: any): VerifyCodeConfirmReqVo {
    return VerifyCodeConfirmReqVoToJSONTyped(json, false);
}

export function VerifyCodeConfirmReqVoToJSONTyped(value?: VerifyCodeConfirmReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'target': value['target'],
        'code': value['code'],
        'scene': value['scene'],
        'userId': value['userId'],
    };
}

